<template>
  <DxDropDownBox
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :value.sync="currentValue"
    :display-expr="cellEditing"

    content-template="contentTemplate"
  >
    <template #contentTemplate="{}">
      <div >
        <div class="text-input">
           <label><b>{{cellEditing}}</b></label>
          <div class="input-group">
            <input 
              v-if="open"
              type="text"
              v-focus="currentValue"
              class="form-control"
              placeholder=""  
              :style="{marginBottom: '10px'}"
              v-model="currentValue"
              @keydown.tab="finishEditing"
              @keydown.enter="finishEditing"
              @change="customInputChanged"
              aria-label="Description">
          </div>
        </div>
        <div class="text-input">
          <div class="input-group" :style="{marginBottom: '10px'}">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
            <input 
              v-if="open"
              v-focus="!currentValue"
              type="text"
              class="form-control"
              placeholder="search..."
              @input="debounce(searchInputChanged, 1000)"
              v-model="customInput"
              aria-label="Description">
          </div>
        </div>
        <!-- <BasicTextInput 
          :customStyles="{marginBottom: '10px'}"
          label="Description" placeholder="search..." ref="searchInput" v-model="customInput"/> -->
				<DxDataGrid
					:data-source="dataSource"
					:allow-column-resizing="true"
					:remote-operations="true"
					:height="800"
					:hover-state-enabled="true"
					:on-selection-changed="onSelectionChanged"
					:show-borders="true"
				>
				<!-- <DxResizable ...
						:element-attr="resizableAttributes">
				</DxResizable> -->
				<DxFilterRow :showOperationChooser="false" :visible="true"/>
					<DxSearchPanel :text="searchInput" :visible="false" :width="460"/>
					<DxColumn :width="90" data-field="MfgCode" cell-template="grid-cell"/>
					<DxColumn :width="160" data-field="PartNumber" cell-template="grid-cell"/>
					<DxColumn :width="300" caption="Description" data-field="Description" cell-template="grid-cell"/>
					<DxColumn :width="100" data-field="StockCode" cell-template="grid-cell"/>
					<DxColumn :width="80" data-field="Retail" cell-template="grid-cell-amount"/>
					<template  #grid-cell="{ data }">
						<div class="cell" style="fontSize:10px">{{ data.text }}</div>
				</template>
					<template  #grid-cell-amount="{ data }">
							<div class="cell">${{ formatCurrency(data.value) }}</div>
					</template>
					<DxPaging
						:enabled="true"
						:page-size="50"
					/>
					<DxScrolling mode="virtual"/>
					<DxSelection mode="single"/>
				</DxDataGrid>
        <span class="my-5"></span>
      </div>
    </template>
  </DxDropDownBox>
</template>
<script>
import {
  DxDataGrid,
  DxPaging,
  DxSelection,
  DxScrolling,
  DxColumn,
  DxSearchPanel,
  DxFilterRow,
} from 'devextreme-vue/data-grid';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { mapState } from 'vuex';
import { DealerService, ProductService } from '@/services';
//import overlay from 'devextreme/ui/overlay';

export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxScrolling,
    DxColumn,
    DxDropDownBox,
    DxFilterRow
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => {}
    },
    cellEditing:{
      type: String,
      default: 'Description'
    },
		openOnMount: {
			type: Boolean,
			default: true
		}
  },
  data() {
    return {
      dataSource: [],
      dataGridKey: 'Id',
      currentValue: null,
      dropDownOptions: { width: 775 },
      dropDownBoxRefName: 'dropDownBoxRef',
      customInput: '',
      open: false,
      timerId: null,
      searchInput: '',
      isHSUS: false
    };
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        if(binding.value) el.focus()
      }
    }
  },
  methods: {
    debounce(func, wait) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(func, wait)
    },
    finishEditing(e){
      this.$refs[this.dropDownBoxRefName].instance.close();
    }, 
    onSelectionChanged(selectionChangedArgs) {
      if(selectionChangedArgs.selectedRowsData.length === 0) return;
      this.currentValue = selectionChangedArgs.selectedRowsData[0][this.cellEditing];
      this.onValueChanged(this.currentValue);
      this.$emit('setProductData', selectionChangedArgs.selectedRowsData[0])
      if(selectionChangedArgs.selectedRowKeys.length > 0) {
        if(!this.$refs[this.dropDownBoxRefName]) return;
        this.$refs[this.dropDownBoxRefName].instance.close();
      }
    },
    async openGrid(){
      await this.$refs[this.dropDownBoxRefName].instance.open()
      // console.log('this.$refs',this.$refs[this.dropDownBoxRefName])
      setTimeout(() => {
        this.open = true;
      }, 25)
    },
    formatCurrency(currency){
      if(typeof(currency) !== 'number') return;
      return currency.toFixed(2);
    },
    searchInputChanged(){
      this.searchInput = this.customInput;
      this.onValueChanged(this.currentValue)
    },
    customInputChanged() {
      this.onValueChanged(this.currentValue);
    },
    getProducts(){
      this.dataSource = ProductService.getDataSource();
    },
    getDealerInfo() {
      let dealerId = this.currentUser.DealerId;
      DealerService.get(dealerId)
        .then(res => {
            const dealer = res;
            this.isHSUS = dealer.StoreCode === 'HSUS'
        })
        .catch(err => {
            console.log('err', err)
        })
    },
  },
  computed: {
    ...mapState(['currentUser'])
  },
  mounted(){
		// This is necessary to have the control appear above modal dialogs 
		// when used in there (for example: in LineItemDetailsDialog)
		//overlay.baseZIndex(10000);

    this.getDealerInfo();

		if (this.openOnMount) {
			this.openGrid();
		}
  },
  created(){
    this.currentValue = this.value;
    this.getProducts();
  }
};
</script>
<style lang="scss" scoped>


  .header {
    color: $primary;
    font-size: 12px;
  }
  .cell {
    color: $ss_grey1;
    font-size: .9rem !important;
  }
  
  .dxDataGrid {
    height: calc(100vh - 10px);
  }

  .dx-widget {
    font-size: 1rem !important;
  }

</style>